import { BrowserRouter, Route, Routes } from "react-router-dom";
import Main from "./modules/Main";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:id" element={<Main />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
